
$( document ).ready(function() {
    
    if($(".partner-login").length > 0){
        if($(".success-message").length > 0){
            $(".portal-form-reset-password").css("display", "none");
        }

        if($(".portal-form-reset-password .alert").length > 0){
            $(".field_element_forgot-password").addClass('error-field').val(emailValue);
        }
    }
});
